import { 
	IEnhancementHostConfig
} from '../enhancements/index'

export type Host = string | RegExp;


export interface IFrontendInitOptions {
  // If true, this will set `env` to dev
  dev?: boolean

  // API Key -> used to identify the project
  apiKey?: string

  // What hosts should we apply enhancements to in dev 
  // useful if we 
  devBackendHosts?: Host[]

  // What environment are we running in? 
  // `dev` is special
  env?: string

  // Useful to display what version of the front end you are running
  frontendCommitHash?: string

  // What staffbar host are you using, this will default to 
  // app.staffbar.com
  staffBarHost?: string
}

// Options that allow us to override how boostrapping happens in dev
export interface IUndocumentedFrontendInitOptions {
  // Overrides the source from which we load the iframe.
  clientSrc?: string

  // Delays the iframe until we've triggered some action, used in the chrome extension
  delayIframeSetup?: boolean

  enhancementHostConfigs?: IEnhancementHostConfig[]

  // Starting display format, used to open staffbar in full screen mode.
  startingDisplayFormat?: string

  // Hosts to filter out of all stores
  ignoredHosts?: []

  // Is the bar the product hosted on the Splash page?
  isStaffBarSplash?: boolean
}

export interface IRequiredBackendInitOptions {
  dev: boolean,
  apiKey: string,
  env: string,
  staffBarHost: string,
}

export type ValidatedBackendInitOptions = IBackendInitOptions & IRequiredBackendInitOptions;

export interface IBackendInitOptions {
  // If set to true, we will _not_ validate any tokens
  dev?: boolean

  // What environment are we running in? 
  // `dev` is special
  env?: string

  // API key to autenticate against the api
  apiKey?: string

  // Useful to say what version of the backend we're running
  backendCommitHash?: string

  // What, if any enhancements you explictly want to disable 
  disabledEnhancements?: []

  // What staffbar host are you using, this will default to 
  // app.staffbar.com
  staffBarHost?: string

  projectDirectory?: string,
}


export interface IRequiredFrontendInitOptions {
  dev: boolean,
  apiKey: string,
  env: string,
  staffBarHost: string,
}


export type ValidatedFrontendInitOptions = IFrontendInitOptions & IRequiredFrontendInitOptions;
